<template>
  <div>
    <div v-if="popupVisible">
      <side-popup title="下级详情" width="100%" padding="0 15px" :popupVisible="popupVisible" @onClose="onClose">
        <div class="csgo-table">
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="name" label="用户名称" align="center">
            </el-table-column>
            <!-- <el-table-column prop="recharge_sub" label="下级累计充值" align="center">
            </el-table-column>
            <el-table-column prop="commission_sub" label="下级累计佣金" align="center">
            </el-table-column> -->
            <el-table-column prop="recharge" label="累计充值" align="center">
            </el-table-column>
            <el-table-column prop="commission" label="累计佣金" align="center">
            </el-table-column>
            <el-table-column prop="source" label="绑定方式" align="center">
            </el-table-column>
            <el-table-column prop="create_time" label="绑定时间" align="center">
            </el-table-column>
          </el-table>
          <div class="csgo-page">
            <el-pagination background :pager-count="5" layout="prev, pager, next" :current-page.sync="searchForm.page" :total="searchForm.totalSize" :page-size="searchForm.limit" @current-change="currentChange">
            </el-pagination>
          </div>
        </div>
      </side-popup>
    </div>
  </div>
</template>

<script>
import SidePopup from "@/g-components/side-black-popup.vue"
export default {
  components: { SidePopup },
  data() {
    return {
      popupVisible: false,
      isMobile: false,
      tableData: [],
      searchForm: {
        totalSize: 0,
        page: 1,
        limit: 20,
        inviter_id: ''
      },
    };
  },
  created() {
    // this.getList();
  },
  methods: {
    onClose() {
      this.popupVisible = false
      this.$emit('onClose', 'onClose')
    },
    toggle(inviter_id) {
      this.isMobile = window.innerWidth < 600
      this.searchForm.searchForm = 1
      this.searchForm.inviter_id = inviter_id
      this.getList()
    },
    currentChange(val) {
      this.searchForm.searchForm = val
      this.getList();
    },
    getList() {
      this.$doGet('/api/hall.Invite/offlineList', this.searchForm).then((res) => {
        this.tableData = res.data.list
        this.searchForm.totalSize = res.data.count
        this.popupVisible = true
      }).catch(() => { })
    }
  },
};
</script>

<style lang="less" scoped>
</style>